import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from '@shared/components';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { getReviewResultFormSchema } from '../../schemas';
import type { ReviewResultFormContextData } from '../../types';
import { useReviewResult } from '../review-result-provider';

import type { ReviewResultFormProviderProps } from './types';

export default function ReviewResultFormProvider(props: Readonly<ReviewResultFormProviderProps>) {
  const { children } = props;

  const ReviewResultFormSchema = getReviewResultFormSchema();

  const formContext = useForm<ReviewResultFormContextData>({
    resolver: zodResolver(ReviewResultFormSchema),
  });

  const { verdict } = useReviewResult();

  useEffect(() => {
    formContext.setValue('verdict', verdict.data);
  }, [verdict.data]);

  return (
    <FormProvider {...formContext}>
      <Form>{children}</Form>
    </FormProvider>
  );
}
